import type { ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { TabSubTitle } from "./TabSubTitle";
import { TabTitle } from "./TabTitle";

interface TabHeaderProps {
  className?: string;
  subtitle?: string;
  subtitleNode?: ReactNode;
  title?: string;
  titleNode?: ReactNode;
}

export const TabHeader = ({
  title,
  titleNode = null,
  subtitle,
  subtitleNode = null,
  className,
}: TabHeaderProps) => (
  <div className={classNames("flex flex-col gap-y-2", className)}>
    {title && <TabTitle>{title}</TabTitle>}
    {titleNode}
    {subtitle && <TabSubTitle>{subtitle}</TabSubTitle>}
    {subtitleNode}
  </div>
);
